// extracted by mini-css-extract-plugin
export default {"info":"InfoBlock_info__GEg+I"};